// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import Typography from '@mui/material/Typography'
import moment from 'moment'
import React, { Component } from 'react'
import { Mutation } from 'react-apollo'
import { i18n } from '../../index'
import EditChecklistQuestionsLink from '../EditChecklistQuestionsLink'
import ChecklistButton from '../ChecklistButton'
import css from './hourlyChecklist.css'
import { upsertHourlyChecklist } from './hourlyChecklistQueries'
const dateFormat = 'YYYY-MM-DD'
type HourlyChecklistType = 'buffet' | 'hall' | 'vitrine' | 'market'
type Props = {
  stationId: string
  currentTime: moment
  title: string
  type: HourlyChecklistType
  questions?: Array<{ id: string; type: string; description: string }>
  statuses: Record<
    string,
    {
      hour: number
      status: boolean
      date: string
    }
  >
}
type State = {
  statuses: Record<
    string,
    {
      hour: number
      status: boolean
      date: string
    }
  >
}

function isLocked(dateOfItem: string, currentTime: string, checkHour: number): boolean {
  const today = moment().format(dateFormat)
  const yesterday = moment().subtract(1, 'days').format(dateFormat)
  const tomorrow = moment().add(1, 'days').format(dateFormat)
  let [hour, minute] = currentTime.split(':')
  hour = Number(hour)
  minute = Number(minute)

  // If hour to check is the first hour of tomorrow
  if (dateOfItem === tomorrow && checkHour === 0 && hour === 23 && minute >= 50) {
    return false
  } else if (dateOfItem === today) {
    if (checkHour === hour || (minute <= 10 && checkHour === hour - 1)) {
      return false
    }

    if (minute >= 50 && checkHour === hour + 1) {
      return false
    }
  } else if (dateOfItem === yesterday && 23 === checkHour && minute <= 10 && 0 === hour) {
    // make sure 23:00's check item yesterday can be checked until 00:10 today, e.g. 00:09
    return false
  }

  return true
}

function HourRow({ hours }: { hours: number[] }) {
  return (
    <>
      {hours.map((hour) => (
        <th key={hour}>{hour}</th>
      ))}
    </>
  )
}

const ChecklistButtonRow = function ({ statuses, currentHour, callback, check }: any) {
  return (
    <>
      {Object.values(statuses).map(({ hour, status, date }) => (
        <td key={hour}>
          <ChecklistButton
            date={date}
            isChecked={status}
            isLocked={isLocked(date, currentHour, hour)}
            timePeriod={hour}
            callback={callback}
            check={check}
          />
        </td>
      ))}
    </>
  )
}

export default class HourlyChecklist extends Component<Props, State> {
  state = {
    statuses: this.props.statuses,
  }
  check = async (date: string, hour: number, currentStatus: boolean, callback: (...args: Array<any>) => any) => {
    const { stationId, type } = this.props

    try {
      await callback({
        variables: {
          stationId,
          hour,
          date,
          type,
          status: !currentStatus,
        },
      })
      const targetStatus = this.state.statuses[`_${hour}`]
      this.setState({
        statuses: {
          ...this.state.statuses,
          [`_${hour}`]: { ...targetStatus, status: !currentStatus },
        },
      })
    } catch (err) {
      // TODO: error handle (sometimes checking an item fails)
    }
  }

  render() {
    const { currentTime = moment(), title, questions = [], stationId } = this.props
    const { statuses } = this.state
    const hours = Object.values(statuses).map((status) => status.hour)
    return (
      <Mutation mutation={upsertHourlyChecklist}>
        {(onMutate) => (
          <div className={css.checkContainer}>
            <Typography variant='h5' className={css.sectionHeader}>
              {title}
            </Typography>
            <div className={css.checksContainer}>
              <table className={css.table}>
                <thead>
                  <tr>
                    <th className={css.timeHeader}>{i18n.t('checkList.time')}</th>
                    {<HourRow hours={hours} />}
                  </tr>
                </thead>
                <tbody>
                  <tr className={css.row}>
                    <td>&nbsp;</td>
                    {
                      <ChecklistButtonRow
                        statuses={statuses}
                        currentHour={currentTime.format('HH:mm')}
                        callback={onMutate}
                        check={this.check}
                      />
                    }
                  </tr>
                </tbody>
              </table>
            </div>
            {questions.length > 0 && (
              <ul className={css.questionList}>
                {questions.map((q) => (
                  <li key={q.id}>{q.description}</li>
                ))}
              </ul>
            )}
            <EditChecklistQuestionsLink to={`/yllapito/toimipaikat/asetukset/${stationId}#tarkastuskysymykset`} />
          </div>
        )}
      </Mutation>
    )
  }
}
